module.exports = new __parcel__URL__("profile.ef97b464.svg").toString();